<template>
        <div style="background-color: rgb(28,28,28);">
            <div class="lb-content1">
                <div class="lb-content" :style="'background-image: url('+bjImg+')'"></div>
                <div class="block phone-lbt"  style="position: relative;top: -360px">
                    <div class="l-arrows cursor-pointer" @click="prev"></div>
                    <div class="r-arrows cursor-pointer" @click="next"></div>
                    <el-carousel never="always" :autoplay="true" ref="carousel"  :interval="5000" @change="carouselChange" height="360px" class="carousel" trigger="click" style="border-radius: 5px">
                        <el-carousel-item class="carousel-item" @click.native="tovr(i)" v-for="(item,i) in lbData" :key="i" :style="'background-image: url('+item+')'">
<!--                            <h3 class="small">{{ item }}</h3>-->
                        </el-carousel-item>
                    </el-carousel>
                </div>
            </div>
            <div class="content-vr">
<!--                <div class="text-white">.</div>-->
                <div class="flex justify-between align-center padding-tb content-vrs1" style="max-width: 1180px;margin: 0rem auto;">
                    <div class="fl">
                        <li class="title-v fl">推荐项目</li>
                        <div class="justify-start flex tj-t-t flex-wrap align-center" style="overflow: hidden;height: 36px;">
                            <a class="tj-item"  v-for="(item,i) in spread" :key="i" @click="isCheck(i,item.id)" :class="item.type?'is-item':''">{{item.name}}</a>
                        </div>
                    </div>
                    <div class="flex justify-end" >
                        <li class="padding-lr hyp  " style="white-space: nowrap; cursor: pointer;" @click="listByCategory(-1, page++,9,1);isrefresh=true"><i :class="isrefresh?'el-icon-loading':'el-icon-refresh'"></i>换一批</li>
                        <div class="flex justify-end align-center " style="cursor: default;line-height: 1;" @click="$router.push({path: '/classify' ,query: {}})">
                            <li style="white-space: nowrap;	" class="cursor-pointer">更多</li>
                            <li class="cuIcon-right"></li>
                        </div>
                    </div>
                </div>
                <div>
                    <vr-scroll class="phone-show" :vrInfo="vr_info"></vr-scroll>
                    <vr-item class="phone-vr-item" :vrInfo="vr_info"></vr-item>
                    <div v-if="vr_info.length===0" >
                        <nullPage style="padding: 50px 0;"></nullPage>
                    </div>
                </div>
            </div>
            <!--    全部项目-->
            <div class="content-vr">
                <div class="flex justify-between align-center padding-tb content-vrs1" style="max-width: 1180px;margin: 0rem auto;">
                    <div class="fl">
                        <li class="title-v fl">全部项目</li>
                    </div>
                    <div class="flex justify-end align-center" style="cursor: default" @click="$router.push({path: '/classify' ,query: {}})">
                        <li style="white-space: nowrap;	" class="cursor-pointer">更多</li>
                        <li class="cuIcon-right"></li>
                    </div>
                </div>
                <div>
                    <vr-item1 :vrInfo1="vr_info1"></vr-item1>
                    <div v-if="vr_info1.length===0" >
                        <nullPage style="padding: 50px 0;"></nullPage>
                    </div>
                </div>
                <div class="genduo bg-white padding-tb" @click="$router.push({path: '/classify' ,query: {}})">
                    <div class="font-15">查看更多</div>
                </div>
            </div>

        </div>
</template>


<script>
    import vrItem from '@/components/vr-item'
    import vrItem1 from '@/components/vr-item1'
    import vrScroll from '@/components/vr-scroll'
    import nullPage from '@/components/nullPage'
    export default {
        name: "home",
        components: {
            vrItem1,vrItem,vrScroll,nullPage
        },
        data(){
            return{
                Activ:0,
                bjImg:0,
                page:2,
                maxPage:null,
                lbData:[],
                // lbData:['https://axure.tdin360.com/kdxt/images/index/u73.png','https://axure.tdin360.com/kdxt/images/index/u74.png'],
                spread:[{id:-1,name:'为你推荐',type:true}],
                // spread:[{name:'为你推荐',type:true},{name:'林权',type:false},{name:'农业知识产权',type:false},{name:'农村集体建设股权',type:false},{name:'房屋所有权和使用权',type:false}],
                vr_info:[],
                vr_info1:[],
                lb_data:[],
                isrefresh:false
                // vr_info:Array(9).fill(vrItem)
            }
        },
        created(){

            this.getBenner() // 轮播
            this.getAategorList() // 分类选项卡列表
            this.listByCategory(-1,1,9,1) // 推荐列表
            this.listByCategory1(0,1,19,0) // 全部列表
        },
        methods: {
            next(){
                this.$refs.carousel.next()
            },
            prev(){
                this.$refs.carousel.prev()
            },
            tovr(e){
                console.log('轮播跳转',this.lb_data[e].url+'|'+e)
                var str = this.lb_data[e].url.search(/http/ig);
                console.log('aaaa',str)
                if(str >= 0){
                    window.open(this.lb_data[e].url,'target');
                }
                // else if(str === -1){
                //     this.$router.push({path: '/vrinfo' ,query: { data: this.lb_data[e].url}})
                // }
            },
            // 获得轮播图
            getBenner(){
                var data = []
              this.$http({
                  url: this.$Api.BannerList,
              }).then((res)=>{
                  console.log('轮播图',res)
                  this.lb_data = res.data
                  res.data.forEach((item,index)=>{
                      data.push(item.imgUrl)
                  })
                  this.lbData = data
                  // console.log(data)
                  this.bjImg = this.lbData[0]
              })
            },
            // 推荐项目分类
            getAategorList(){
                var data = []
                this.$http({
                    url: this.$Api.AategorList,
                    params:{
                        // page:1           // 默认1
                        // pageSize:10      // 默认10
                    }
                }).then((res)=>{
                    res.data.forEach((item,index)=>{
                        this.spread.push({
                                id: item.id,
                                name: item.name,
                                type: false
                            })
                    })
                    // this.spread = data
                    // console.log(data)
                })
            },
            // 检测dom节点改变时获得值，改变背景
            carouselChange(e){
                // console.log(e)
                this.Activ=e
                this.bjImg = this.lbData[e]
            },
            // 选项卡切换
            isCheck(is,id){
                this.spread[is].type = true
                console.log(is,id)
                for(var i = 0;i < this.spread.length;i++){
                    if(i === is){
                        continue ;
                    }
                    this.spread[i].type = false;
                    console.log(this.spread[i].type)
                }
                this.listByCategory(id,1,9,1)
            },
            // 当切换到最后一页再点击换第一页数据
            checkPage(){
                console.log(this.page+'|'+this.maxPage)
                if(this.page > this.maxPage){
                    this.page = 1
                    this.listByCategory(-1,1,9,1) // 推荐列表
                }
            },
            // 推荐列表
            listByCategory(categoryId,page,pageSize,sortType){
                var vrData = []
                this.$http({
                    url: this.$Api.listByCategory,
                    params: {
                        categoryId:categoryId,  // 分类id默认1
                        page:page,              // 当前页数默认1
                        pageSize:pageSize,      // 每页条数默认10
                        sortType:sortType       // 排序规则，0:最新, 1:人气。默认为0
                    }
                }).then(res=>{
                    this.isrefresh=false
                    this.maxPage = res.data.length
                    this.checkPage()
                    if(res.data.length !==0){
                        this.vr_info = res.data
                    }
                    console.log('获取项目分类列表',res.data)
                }).catch(err=>{
                    this.isrefresh=!this.isrefresh
                })
            },
            // 全部列表
            listByCategory1(categoryId,page,pageSize,sortType){
                var vrData = []
                this.$http({
                    url: this.$Api.listByCategory,
                    params: {
                        categoryId:categoryId,
                        page:page,
                        pageSize:pageSize,
                        sortType:sortType
                    }
                }).then(res=>{
                    this.maxPage = res.data.length
                    this.vr_info1 = res.data
                    console.log('全部项目',this.vr_info1)
                })
            },
        }
    }
</script>

<style scoped>
    li{
        list-style: none;
    }
    .l-arrows{
        height: 56px;
        width: 56px;
        /*background-color: red;*/
        background-image: url("../../assets/svg/Gt.svg");
        z-index: 100;
        position: absolute;
        left: 12%;
        top: 42.5%;
    }
    .r-arrows{
        height: 56px;
        width: 56px;
        /*background-color: red;*/
        z-index: 100;
        position: absolute;
        background-image: url("../../assets/svg/Gt.svg");
        transform: rotate(180deg);
        right: 12%;
        top: 42.5%;
    }
    .genduo{
    }
    .genduo >div{
        width: 150px;
        height: 40px;
        border-radius:75px ;
        margin:0 auto;
        background-color: rgba(255, 92, 56, 0.15);
        color: #ff5c38;
        text-align: center;
        line-height: 40px;
        cursor: default;
    }
    .genduo > div:hover {
        background-color: rgba(255, 92, 56, 0.2);
    }
    .carousel {
        max-height: 360px;
        /*width: 1184px;*/
        max-width: 1180px;
        margin:0 auto;
    }
    .lb-content1{
        overflow:hidden;
        height: 440px;
        width: 100%;
    }
    .lb-content{
        overflow:hidden;
        height: 440px;width: 100%;
        background-size: 100% 100%;
        transform: scale(1.2);transition:all 0.5s ease-in-out;filter: blur(50px);
        /*background-color: #000;*/
    }

    .carousel-item{
        background-size: 100% 100%;
    }
    .content-vr{
        /*height: 800px;*/
        width: 100%;
        background-color: #fff;
    }
    .el-carousel__item{
        opacity: 0.5;
    }
    .is-active{
        opacity: 1;
    }

    .el-carousel__item.is-animating{
        transition: opacity 0.5s  ease-in-out !important;
    }
    .title-v{
        font-size: 24px;
        font-weight: bold;
    }
    .tj-item{
        white-space: nowrap;
        background-color: rgba(239, 239, 244, 1);
        flex-shrink: 1;
        text-align: center;
        /*line-height: 32px;*/
        /*height: 32px;*/
        padding: 6px 20px;
        border-radius:49px;
        font-size: 13px;
        margin-left: 4px;
        margin-bottom: 5px;
    }
    .tj-item:hover{
        cursor: pointer;
            /*cursor: default;*/
    }
    .is-item{
        background: linear-gradient(270deg, rgba(255, 46, 0, 1) 16%, rgba(255, 161, 0, 1) 84%);
        color: #fff;
    }

    @media only screen and (max-width: 767px) {
        .l-arrows{
            display: none !important;
        }
        .r-arrows{
            display: none !important;
        }
    }
    @media only screen and (max-width: 992px) {
        .tj-t-t{display: none}
    }
    @media only screen and (min-width: 992px) {
        .l-arrows{
            left: 10%;
        }
        .r-arrows{
            right: 10%;
        }
    }
    @media only screen and (min-width: 1200px) {

    }
    @media only screen and (min-width: 1920px) {

    }

</style>
